import React, { CSSProperties, PropsWithChildren, PureComponent } from 'react';
import { Flex } from './Flex';
import { CloseOutlined, MoreOutlined } from '@ant-design/icons';
import './SelectionLabel.less';
import { PopoverMenu } from './PopoverMenu';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { MenuItemsFunction } from 'app/components/dashboard/common/MenuUtils';

interface SelectionLabelProps {
    visible: boolean;
    title: string;
    subTitle?: string;
    onSelectAll?: () => void;
    onClearSelection?: () => void;
    extraMenuItems?: ItemType[] | MenuItemsFunction;

    style?: CSSProperties;
}

/**
 * Component that either shows a selection label that is meant to show the number of selected elements (title/subTitle) or children.
 * It has a 'visible' property that allows tho control whether the label is visible or not.
 */
export class SelectionLabel extends PureComponent<PropsWithChildren<SelectionLabelProps>> {
    handleClearSelection = () => {
        this.props.onClearSelection?.();
    };

    render() {
        const selectionLabelClassName = 'selection-label' + (this.props.visible ? ' visible' : '');
        const selectionLabelContentClassName = 'selection-label-content' + (this.props.visible ? ' hidden' : '');
        return (
            <div className="selection-label-content-wrapper" style={this.props.style}>
                <div className="selection-label-wrapper" style={{ position: 'absolute' }}>
                    <Flex className={selectionLabelClassName}>
                        <Flex direction="horizontal" className="selection-label-tag">
                            <Flex direction="vertical">
                                <Flex className="title">{this.props.title}</Flex>
                                <Flex className="subtitle">{this.props.subTitle}</Flex>
                            </Flex>
                            <Flex className="more-button" onClick={e => e.stopPropagation()}>
                                <SelectionLabelMoreMenu
                                    onSelectAll={this.props.onSelectAll}
                                    extraMenuItems={this.props.extraMenuItems}
                                />
                            </Flex>
                        </Flex>
                        <Flex size="2em" className="selection-label-close">
                            <CloseOutlined onClick={this.handleClearSelection} />
                        </Flex>
                    </Flex>
                </div>
                <div className={selectionLabelContentClassName}>{this.props.children}</div>
            </div>
        );
    }
}

interface SelectionLabelMoreMenuProps {
    onSelectAll?: () => void;
    extraMenuItems?: ItemType[] | MenuItemsFunction;
}

class SelectionLabelMoreMenu extends PureComponent<SelectionLabelMoreMenuProps> {
    handleMoreMenuItemClick = (key: string) => {
        switch (key) {
            case 'select-all':
                this.props.onSelectAll?.();
                break;
        }
    };
    getMenuItems = (): ItemType[] => {
        const menuItems: ItemType[] = [{ key: 'select-all', label: 'Select all' }];
        if (this.props.extraMenuItems) {
            if (typeof this.props.extraMenuItems === 'function') menuItems.push(...this.props.extraMenuItems());
            else menuItems.push(...this.props.extraMenuItems);
        }
        return menuItems;
    };
    render() {
        return (
            <PopoverMenu onMenuItemClick={this.handleMoreMenuItemClick} menuItems={this.getMenuItems}>
                <MoreOutlined />
            </PopoverMenu>
        );
    }
}
